<section class="home-container">
  <div class="header-info">
    <dynamic-card-banner [cardConfig]="cardDetails" class="custom-card-style"></dynamic-card-banner>
  </div>
  <div class="home-list-container">
    @if(beginRender){
    <div class="page-container-title">{{turnOverReportLabel}}</div>
    <app-page-container [isLoading]="isLoading" [props]="props" [layoutType]="LayoutType.Tab" [tabConfig]="tabSchema">
    </app-page-container>
    }
  </div>
</section>